/* istanbul ignore file */
import styled, { css } from 'styled-components';

const Card = styled.div<{ $palette: 'blue' | 'purple' }>(
  ({ theme, $palette }) => css`
    width: 100%;
    max-width: 540px;
    height: 1298px;
    max-height: 1298px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding-top: ${theme.sz.s8};
    padding-bottom: ${theme.sz.s8};
    padding-left: ${theme.sz.s4};
    padding-right: ${theme.sz.s4};
    border-radius: ${theme.bo.medium};
    border-style: solid;
    border-width: 3px;
    overflow: hidden;

    ${
      $palette === 'blue' &&
      css`
        background-color: ${theme.co.secondary0};
        border-color: ${theme.co.information80};
      `
    }

    ${
      $palette === 'purple' &&
      css`
        background-color: ${theme.co.secondary0};
        border-color: #bfa3ed; // No alternatives in theme
      `
    }

    @media (min-width: ${theme.sz.md}) {
      padding-top: ${theme.sz.s10};
      padding-bottom: ${theme.sz.s10};
      padding-left: ${theme.sz.s10};
      padding-right: ${theme.sz.s10};
    }

    @media (min-width: 1152px) {
      height: 1236px;
      max-height: 1236px;
    }
  `,
);

export default Card;
